export const USE_CASES = [
  {
    key: "nda",
    label: "NDA Review",
    number: "01",
    tag: "Contract",
    for_who: "Solo & small-firm lawyers, founders receiving inbound NDAs.",
    checks: [
      "Mutual vs one-way",
      "Definition of Confidential Information",
      "Term & survival period",
      "Residuals & carve-outs",
      "Governing law & venue",
    ],
    output: "Prioritized red/amber/green findings, missing clauses, client memo.",
  },
  {
    key: "msa",
    label: "MSA / Vendor Contract",
    number: "02",
    tag: "Contract",
    for_who: "Buyers or vendors negotiating a services agreement.",
    checks: [
      "Liability cap & carve-outs",
      "Indemnity direction",
      "IP ownership & work product",
      "Termination for convenience",
      "Auto-renewal & payment terms",
      "Data protection / DPA",
    ],
    output: "Findings from your side of the deal, plus a redline-ready memo.",
  },
  {
    key: "lease",
    label: "Lease Decode",
    number: "03",
    tag: "Real Estate",
    for_who: "Renters, small-business owners signing an office/retail lease.",
    checks: [
      "Rent, deposits, & fees",
      "Term & renewal",
      "Early termination",
      "Pet / guest / maintenance rules",
      "Hidden surprise charges",
    ],
    output: "Plain-English breakdown, dates, fees, and traps.",
  },
  {
    key: "invoice",
    label: "Invoice Audit",
    number: "04",
    tag: "Finance",
    for_who: "AP teams, freelancers, small-business owners.",
    checks: [
      "Vendor, invoice #, dates",
      "Line items & totals math",
      "Tax breakdown",
      "Missing fields",
    ],
    output: "Extracted fields + red flags on math and completeness.",
  },
  {
    key: "resume",
    label: "Resume vs Job Description",
    number: "05",
    tag: "Hiring",
    for_who: "Recruiters, hiring managers, agencies.",
    checks: [
      "Must-have skills present or missing",
      "Years of experience vs requirement",
      "Domain fit",
      "Gaps as interview questions",
    ],
    output: "Fit summary, gap list, and interview-question memo.",
  },
  {
    key: "insurance",
    label: "Insurance Policy Decode",
    number: "06",
    tag: "Coverage",
    for_who: "Small-business owners, individual policyholders.",
    checks: [
      "Coverage limits & sub-limits",
      "Deductibles",
      "Key exclusions",
      "Cancellation terms",
      "Notice-of-claim windows",
    ],
    output: "Plain-English decode of what's covered, what's not.",
  },
];

export const USE_CASE_MAP = Object.fromEntries(USE_CASES.map((u) => [u.key, u]));
